import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';

import {removeTagFromSearchParams} from 'shared/lib/filterHelper';

const useRemoveTagFilter = (): (_tag: string) => void => {
    const [searchParams, setSearchParams] = useSearchParams();

    return useCallback((tag: string) => {
        setSearchParams(removeTagFromSearchParams(searchParams, tag));
    }, [searchParams, setSearchParams]);
};

export default useRemoveTagFilter;
